import { Navigate, Outlet, redirect } from "react-router-dom";

import { ROUTES } from "@/shared/model/routes";
import { useSession } from "@/shared/model/session";

/**
 * Protected route: редирект неавторизованных пользователей на home
 * Использует getAuthHeaders() для чтения актуального состояния из localStorage.
 */
export function ProtectedRoute() {
  const authHeaders = useSession.getState().getAuthHeaders();

  if (!authHeaders) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return <Outlet />;
}

export async function protectedLoader() {
  const session = useSession.getState();
  const authHeaders = session.getAuthHeaders();

  if (!authHeaders) {
    return redirect(ROUTES.HOME);
  }

  // Если токен истекает скоро и нет refresh token — редирект
  if (session.isTokenExpiringSoon() && !session.tokens?.refreshToken) {
    return redirect(ROUTES.HOME);
  }

  return null;
}

/**
 * Guest-only route: редирект авторизованных пользователей на products
 * Используется для login, register, reset-password страниц
 *
 * Используем getAuthHeaders() вместо isAuthenticated, так как getAuthHeaders()
 * всегда читает напрямую из localStorage, избегая stale state при logout.
 */
export function GuestRoute() {
  const authHeaders = useSession.getState().getAuthHeaders();

  if (authHeaders) {
    return <Navigate to={ROUTES.PRODUCTS} replace />;
  }

  return <Outlet />;
}

export async function guestLoader() {
  const authHeaders = useSession.getState().getAuthHeaders();

  if (authHeaders) {
    return redirect(ROUTES.PRODUCTS);
  }

  return null;
}
